import apiClient from '@/lib/api-client';

export interface ProfileExtras {
  /** Display-only, resolved server-side from the caller's OWN session gln (h12-1 pattern). */
  companyName: string | null;
}

/**
 * Read-only profile extras (h12-3). Name/email/gln already live in the session (AuthUser) —
 * this call ONLY fetches the company name, since that isn't part of the session payload.
 */
export async function getProfile(): Promise<{ data: ProfileExtras }> {
  const response = await apiClient.get<{ data: ProfileExtras }>('/me/profile');
  return response.data;
}
